/**
 * Formats a time value in seconds to a readable string format.
 * Example: 185 seconds -> "03:05.0"
 */
export const formatTime = (time: number): string => {
  const totalSeconds = Math.max(0, time);
  
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const tenths = Math.floor((totalSeconds % 1) * 10);
  
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${tenths}`;
};